import '../App.css'; // Import your App.css file
import Navbar from '../Navbar';
import { Link } from 'react-router-dom';

const AnnouncementsPage = () => {
  return (
    <div>
      <Navbar />
      <div className='main-content'>
        <div className='border-bottom blue-bg'>
          <div className='container text-center padding-top padding-bottom'>
            <div className='col-12-lg'>
              <h1>Announcements</h1>
              <p>
                Any updates to the information provided prior to November 8th
                will be updated below. We will also email you the most important
                updates. Once we are in Mexico, all updates and communication
                will be via our WhatsApp Community, so be sure to download the
                app before the trip!
              </p>
            </div>
          </div>
        </div>
        <div className='border-bottom'>
          <div className='container padding-top padding-bottom'>
            <div className='col-12-lg'>
              <h2>RSVP Deadline and Meal Preferences</h2>
              <h3>July 29, 2025</h3>
              <p>
                Hi Everyone, we have a quick update as we are entering the last
                few months before the trip!
              </p>

              <h3>Wedding Food Preferences</h3>
              <p>
                The full menu is now on the website and there is now an option
                on the RSVP page where you will be able to pick your main course
                option or dietary restrictions for each guest. Please take the
                time to go onto the website and pick one whenever you get a
                chance - we don't have a set deadline from the vendor for these
                numbers yet but they like to let us know of these things pretty
                last-minute. If you don't pick (or just don't have a
                preference), you will be assigned the less popular choice in
                order to make the numbers more even. If none of the options are
                okay for you, please let us know.
              </p>
              <p>
                For your reference, the website is at wedding.amandahehr.com.
                Your login information was sent in our first email. If you are
                having trouble logging in or selecting your food choice, let us
                know.
              </p>

              <h3>RSVP Deadline</h3>
              <p>
                Our RSVP deadline is approaching. Chances are you have already
                talked to us and we know your status, so you aren't getting
                kicked out if you don't go online in the next few days and
                change it there. But to make our counting easier, please double
                check/change your RSVP status on the website when you go on to
                select your meal preferences.
              </p>

              <h3>Travel To/From the Hotel</h3>
              <p>
                Unless your booking specifically stated that it includes
                transportation to and from the airport, you will need to book
                transportation.
              </p>

              <h4>Private or Shared Transfers</h4>
              <p>
                Private vans can be booked, and there are some companies that
                will do multiple stops along the way (though these don't seem
                much cheaper). You can shop around at some different companies
                but expect these to cost around $150USD for round-trip and up to
                8 people. So, if you can coordinate with anyone else to form a
                group and split the cost, that is the most efficient. Here are a
                few links to get you started:
              </p>
              <ul>
                <li>
                  <a href='https://www.airportcancun.com/transportation/quote'>
                    https://www.airportcancun.com/transportation/quote
                  </a>
                </li>
                <li>
                  <a href='https://www.cancunairport.com/taxi.html'>
                    https://www.cancunairport.com/taxi.html
                  </a>
                </li>
                <li>
                  <a href='https://www.canadatransfers.com/transfers-rate/cancun-airport'>
                    https://www.canadatransfers.com/transfers-rate/cancun-airport
                  </a>
                </li>
              </ul>
              <p>
                You also may be able to call the hotel and get them to book your
                transfer, or add it on to your booking through expedia or
                whatever service you used.
              </p>

              <h4>Public Transport</h4>
              <p>
                If you want a cheaper option that you don't need to book, there
                is an ADO bus that will run from the airport down to Playa del
                Carmen. From there you would need to catch a taxi or colectivo
                to the hotel.
              </p>

              <h3>Whatsapp Group</h3>
              <p>
                Finally, a reminder that we have a whatsapp group to make
                communication easier for the wedding - you can find links and
                details on the website. This would be a good place if you want
                to coordinate with any other groups to see if flight times line
                up to share a shuttle from the airport. For bonus points, if
                you're already in the group, take a second to make sure your
                Whatsapp account has a name so that you don't show up as just a
                phone number to anyone who doesn't have you in their contacts
                list - from the main screen of the app, open the ... menu and go
                to settings. At the top will be your profile photo and name, you
                can click in there and edit it.
              </p>

              <p>
                Hope you have a great rest of your summer, and let us know if
                you have any questions!
              </p>
            </div>
          </div>
        </div>

        <div className='border-bottom'>
          <div className='container padding-top padding-bottom'>
            <div className='col-12-lg'>
              <h2>Booking Details</h2>
              <h3>Jan 11, 2025</h3>
              <p>
                Happy new year everyone! We have just booked our flight and
                resort, and wanted to pass along the information you may need
                whenever you plan to book.
              </p>
              <h3>Our Booking Details</h3>
              <p>
                <b>Flight: </b>YVR to CUN Air Canada flight 1314; Departs 8:10am
                Nov 8; Arrives 5:10pm Nov 8 <br />
                <b>Resort:</b> Occidental at Xcaret; Deluxe Room; Check-in Nov
                8; Check-out Nov 15; added request for room in building 18, 19,
                or 20.
              </p>
              <h3>Room Options</h3>
              <p>
                There are 4 tiers of rooms available at the resort:
                <br />
                <b>1. Deluxe</b> is the basic/standard accommodation. For
                7-nights stay you get 4 a-la-carte dinners.
                <br />
                <b>2. Deluxe Concierge:</b> same rooms as the Deluxe rooms, but
                they include nicer amenities (better brand of soaps), a small
                welcome package, and slippers and a bathrobe. <br />
                <b>3. Deluxe Plus:</b> same additions as Deluxe Concierge, and
                these rooms are located specifically in buildings 14-17
                surrounding a pool that is only accessible if you book this
                tier. It also includes a better in-room bar. <br />
                <b>4. Royal Level:</b> all royal-level rooms are located in the
                back area of the park. They are nicer rooms that include all of
                the top amenities. Also being royal level includes access to the
                pool and additional restaurant (that you can eat at on
                non-a-la-carte-nights instead of the buffet) in the royal level
                area, and an additional exclusive lounge.
                <br />
              </p>
              <img
                className='img'
                src='/img/resortmap.png'
                style={{ maxWidth: '500px', height: 'auto' }}
              ></img>
              <h3>Booking the Resort and Flights</h3>
              <p>
                If you have a travel agent/company that you like to use, feel
                free to look into their options. Otherwise, we've done some
                comparisons for the current options available online (as of Jan
                11):
              </p>
              <ul>
                <li>
                  Booking a flight + stay package through expedia is the
                  cheapest option we could find.{' '}
                  <b>
                    Note the first prices they show you will not be direct
                    flights.
                  </b>
                </li>
                <li>
                  Note that if you are interested in booking a Deluxe Plus room,
                  the only place we could find this option was booking through
                  the Barcelo directly. You also have the option of calling to
                  book through Barcelo on the phone, which they told us could
                  lead to better deals - if you want to go for Deluxe Plus or
                  Royal Level, it is probably worth looking into this option.{' '}
                </li>
                <li>
                  We ended up booking our resort stay on Hotels.com and the
                  flights directly through Air Canada, because we are staying in
                  the area for a few extra days but moving to a different hotel.
                </li>
              </ul>
              <p>
                If you have any other questions or want to talk to us about
                anything else before booking feel free to reach out!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementsPage;
